<template>
  <div>
    <h4 class="form-head mt-5 mb-2">{{ title }}</h4>

    <Transition name="dg-zoom">
      <p class="text-center px-4 mt-2" v-show="activeDiscount">Discount unlocked! Enjoy {{ activeDiscount }}% off your selected plan.<br> Don’t wait—it’s time to save!</p>
    </Transition>

    <div class="btn-set">
      <button v-for="(info, tierKey) in tiers" :key="tierKey" type="button" @click="handleClick(tierKey)" class="btn btn-default text-capitalize" :class="isActive(tierKey) ? 'active' : ''">
        <span>{{info.label}} / {{ info.discount }}% Off</span><br>
        <span class="text-discount">{{ priceCents[tierKey] | toCurrency }}</span>
      </button>
      <button class="btn btn-default text-capitalize" :class="isActive('standard') ? 'active' : ''" type="button" @click="$emit('tier:picked', 'standard')">
        <span>One Time Visit</span><br>
        <span class="text-discount">{{ priceCents.standard | toCurrency }}</span>
      </button>
    </div>

  </div>
</template>
<script>
import Vue from 'vue'
import VueConfetti from 'vue-confetti';

Vue.use(VueConfetti)

export default {
  components: {
    VueConfetti
  },
  props: {
    selectedTier: {
      type: String
    },
    title: {
      type: String,
      default: "Select if desired"
    },
    tiers: {
      type: Object,
      required: true
    },
    priceCents: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    activeDiscount() {
      if (this.selectedTier && (this.tiers[this.selectedTier])) {
        return this.tiers[this.selectedTier].discount
      }
    }
  },
  methods: {
    isActive(tierKey) {
      return this.selectedTier == tierKey
    },
    handleClick(tierKey) {
      this.$emit('tier:picked', tierKey);
      this.$confetti.start({  particlesPerFrame: 1.25,});
      setTimeout(() => {
        this.$confetti.stop();
      }, 2000);
    }
  }
}
</script>

<style>
.text-discount {
  font-size: 12px;
}
</style>
